import React, { useEffect } from "react"
import withStyles from "react-jss"
import { bounds, container, MOBILE_BREAKPOINT } from "../../data/globalStyles"
import { useSpring, animated as a } from "react-spring"
import { lemon, lime, twist } from "../../assets"

const styles = {
  container: {
    ...container,
    pointerEvents: "none",
    zIndex: 3,
  },
  bounds: {
    ...bounds,
    position: "relative",
    height: "100%",
  },
  img: {
    position: "absolute",
    height: "150px",
    transformOrigin: "center",
    "@media only screen and (max-width: 820px)": {
      height: "120px",
    },
    "@media only screen and (max-width: 760px)": {
      height: "100px",
    },
    "@media only screen and (max-width: 580px)": {
      height: "85px",
    },
  },
}

const FruitsImage = ({ classes, animate }) => {
  //console.log(MOBILE_BREAKPOINT)

  const INIT_POSITION =
    window.innerWidth < MOBILE_BREAKPOINT
      ? {
          limeTop: "100%",
          limeLeft: "97%",
          lemonTop: "77%",
          lemonLeft: "-0.5%",
          twistTop: "23%",
          twistLeft: "93%",
          transformLime: "translate(-50%, -50%) rotate(100deg)",
          transformTwist: "translate(-50%, -50%) rotate(-70deg)",
          transform: "translate(-50%, -50%) rotate(-80deg)",
        }
      : {
          limeTop: "100%",
          limeLeft: "100%",
          lemonTop: "40%",
          lemonLeft: "-2%",
          twistTop: "10%",
          twistLeft: "100%",
          transformLime: "translate(-50%, -50%) rotate(0deg)",
          transformTwist: "translate(-50%, -50%) rotate(0deg)",
          transform: "translate(-50%, -50%) rotate(0deg)",
        }
  const FINAL_POSITION =
    window.innerWidth < MOBILE_BREAKPOINT
      ? {
          limeTop: "20%",
          limeLeft: "93%",
          lemonTop: window.innerHeight < 700 ? "140%" : "105%",
          lemonLeft: "80%",
          twistTop: "52%",
          twistLeft: "8%",
          transformLime: "translate(-50%, -50%) rotate(455deg)",
          transformTwist: "translate(-50%, -50%) rotate(90deg)",
          transform: "translate(-50%, -50%) rotate(90deg)",
        }
      : {
          limeTop: "10%",
          limeLeft: "0%",
          lemonTop: "105%",
          lemonLeft: "100%",
          twistTop: "70%",
          twistLeft: "0%",
          transformLime: "translate(-50%, -50%) rotate(90deg)",
          transformTwist: "translate(-50%, -50%) rotate(90deg)",
          transform: "translate(-50%, -50%) rotate(90deg)",
        }

  const [anim, animApi] = useSpring(() => ({
    ...INIT_POSITION,
    config: {
      mass: 2,
      tension: 45,
      friction: 12,
    },
  }))

  useEffect(() => {
    if (animate) {
      animApi.start(FINAL_POSITION)
    } else {
      animApi.start(INIT_POSITION)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate])

  return (
    <div className={classes.container}>
      <div className={classes.bounds}>
        <a.img
          className={classes.img}
          src={lime}
          style={{
            top: anim.limeTop,
            left: anim.limeLeft,
            transform: anim.transformLime,
          }}></a.img>
        <a.img
          className={classes.img}
          src={lemon}
          style={{
            top: anim.lemonTop,
            left: anim.lemonLeft,
            transform: anim.transform,
          }}></a.img>
        <a.img
          className={classes.img}
          src={twist}
          style={{
            top: anim.twistTop,
            left: anim.twistLeft,
            transform: anim.transformTwist,
          }}></a.img>
      </div>
    </div>
  )
}

export default withStyles(styles)(FruitsImage)
